export default "<change-password-form [email]=\"email\"></change-password-form>"